import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import { FormControl, Input } from "@mui/material";
import Alert from "@mui/material/Alert";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Paper from "@mui/material/Paper";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { FormHelperText } from "@mui/material";
import { ReferralDiscountForm, OtherDiscountForm } from "./checkDiscount";
import Pay from "./Pay";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { checkRefferlCodeForUseApi } from "../../../../../services/marketingApi";
import { checkDiscountCodeForUseApi } from "../../../../../services/discountApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
import { getAuthUserinfoApi } from "../../../../../services/authApi";

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const steps = ["انتخاب پکیج", "کدهای تخفیف", "تایید نهایی"];

export default function Checkout(props) {
  const { selectProduct, selectedProduct } = props;
  const [activeStep, setActiveStep] = React.useState(1);
  const [mobileNo, setMobileNo] = React.useState(false);
  const [userReferralCode, setUserReferralCode] = React.useState(false);
  const [responseReferralMessage, setResponseReferralMessage] = React.useState({
    cleraButton: false,
    resMessage: "",
    disableReferralInput: false,
  });
  const [referralCodeToken, setReferralCodeToken] = React.useState({
    Discount: 0,
    message: "بدون کد معرف",
    Token: "",
  });
  const [discountCodeMessage, setDiscountCodeMessage] = React.useState({
    cleraButton: false,
    resMessage: "",
    disableDiscountInput: false,
  });
  const [discountCodeToken, setDiscountCodeToken] = React.useState({
    Discount: 0,
    message: "بدون کد معرف",
    codeToken: "",
  });

  const handleReferralMessage = (data) => {
    setResponseReferralMessage({ ...responseReferralMessage, ...data });
    if (!data.cleraButton && !data.disableReferralInput)
      setReferralCodeToken({ Discount: 0, message: "بدون کد معرف", Token: "" });
  };

  const handleDiscountCodeMessage = (data) => {
    setDiscountCodeMessage({ ...discountCodeMessage, ...data });
    if (!data.cleraButton && !data.disableDiscountInput)
      setDiscountCodeToken({
        Discount: 0,
        message: "بدون کد معرف",
        codeToken: "",
      });
  };

  const checkRefferlCodeForUse = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...");
    try {
      handleReferralMessage({
        disableReferralInput: true,
        resMessage: "درحال بررسی",
      });
      const response = await checkRefferlCodeForUseApi(data);
      const resData = checkResponseData(response);
      if (resData["success"]) {
        toast.update(toastMsg, {
          render: resData["message"] || "درخواست انجام شد",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
        if (resData["data"]["data"].length > 0) {
          const {
            Discount,
            message,
            codeToken: Token,
          } = resData["data"]["data"][0];
          handleReferralMessage({
            cleraButton: true,
            disableReferralInput: true,
            resMessage: ` میزان تخفیف ${Discount} درصد و ${message}`,
          });
          setReferralCodeToken({ Discount, message, Token });
          // if (resData["message"]) customToastify("info", resData["message"]);
        }
      } else {
        toast.update(toastMsg, {
          render: resData["message"] || "اتفاق غیر منتظره پیش آمده است",
          type: "info",
          isLoading: false,
          autoClose: 3000,
        });
        handleReferralMessage({
          cleraButton: true,
          disableReferralInput: true,
          resMessage: resData["message"],
        });
        setReferralCodeToken({
          Discount: 0,
          message: resData["message"],
          Token: "",
        });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      // console.log("xasdasd");
      handleReferralMessage({
        cleraButton: false,
        disableReferralInput: false,
        resMessage: errData["message"],
      });

      let errMsg = errData["titles"] || errData["message"];
      toast.update(toastMsg, {
        render: errMsg || "مشکلی وجود دارد",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      console.error(error);
    }
  };

  const checkDiscountCodeForUse = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...");
    try {
      handleDiscountCodeMessage({
        disableDiscountInput: true,
        resMessage: "درحال بررسی",
      });
      const response = await checkDiscountCodeForUseApi({
        ...data,
        ...{ discountFor: "packages" },
      });
      const resData = checkResponseData(response);
      if (resData["success"]) {
        toast.update(toastMsg, {
          render: resData["message"] || "درخواست انجام شد",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
        if (resData["data"]["data"].length > 0) {
          const { Discount, message, codeToken } = resData["data"]["data"][0];
          handleDiscountCodeMessage({
            cleraButton: true,
            disableDiscountInput: true,
            resMessage: ` میزان تخفیف ${Discount} درصد و ${message}`,
          });
          setDiscountCodeToken({ Discount, message, codeToken });
          // if (resData["message"]) customToastify("info", resData["message"]);
        }
      } else {
        toast.update(toastMsg, {
          render: resData["message"] || "اتفاق غیر منتظره پیش آمده است",
          type: "info",
          isLoading: false,
          autoClose: 3000,
        });
        handleDiscountCodeMessage({
          cleraButton: true,
          disableDiscountInput: true,
          resMessage: resData["message"],
        });
        setDiscountCodeToken({
          Discount: 0,
          message: resData["message"],
          Token: "",
        });
      }
    } catch (error) {
      // console.log("0000000000");
      const errData = checkErrorMessage(error);
      handleDiscountCodeMessage({
        cleraButton: false,
        disableDiscountInput: false,
        resMessage: errData["message"],
      });
      let errMsg = errData["titles"] || errData["message"];
      toast.update(toastMsg, {
        render: errMsg || "مشکلی وجود دارد",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      console.error(error);
    }
  };

  const getAuthUserinfo = async () => {
    try {
      const response = await getAuthUserinfoApi({});
      const resData = checkResponseData(response);
      if (resData["success"]) {
        if (resData["data"]) {
          if (resData["data"]["data"] && resData["data"]["data"].length > 0) {
            if (resData["data"]["data"][0]["registerCode"])
              setUserReferralCode(resData["data"]["data"][0]["registerCode"]);
            if (resData["data"]["data"][0]["phoneNumber"])
              setMobileNo(resData["data"]["data"][0]["phoneNumber"]);
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  // تنظیمات نمایش صفحه
  const calculatePrice = () => {
    let price = selectedProduct.price;
    price = price - (price * referralCodeToken.Discount) / 100;
    price = price - (price * discountCodeToken.Discount) / 100;
    return price / 10000;
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
      // selectProduct(false);
      case 1:
        return (
          <>
            <ReferralDiscountForm
              checkRefferlCodeForUse={checkRefferlCodeForUse}
              selectedProduct={selectedProduct}
              responseReferralMessage={responseReferralMessage}
              handleReferralMessage={handleReferralMessage}
              userReferralCode={userReferralCode}
            />
            {/* <OtherDiscountForm
              checkDiscountCodeForUse={checkDiscountCodeForUse}
              selectedProduct={selectedProduct}
              discountCodeMessage={discountCodeMessage}
              handleDiscountCodeMessage={handleDiscountCodeMessage}
            /> */}
            <Paper sx={{ border: "double 5px", mt: 1, textAlign: "center" }}>
              <Typography align="center" sx={{ fontWeight: "bold" }}>
                پس از پر شدن ظرفیت هر کد، کد غیر فعال خواهد شد(ظرفیت محدود)
              </Typography>
              <Typography align="center" sx={{ fontSize: "12px" }}>
                «در صورت اتمام ظرفیت،لطفا درخواست فعال سازی دوباره نفرمایید»
              </Typography>
            </Paper>
          </>
        );
      case 2:
        return (
          <Pay
            referralCodeToken={referralCodeToken}
            discountCodeToken={discountCodeToken}
            selectedProduct={selectedProduct}
            mobileNo={mobileNo}
          />
        );
      default:
        throw new Error("Unknown step");
    }
  }

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
    if (activeStep - 1 == 0) selectProduct(false, "", 0);
  };

  React.useEffect(() => {
    getAuthUserinfo();
  }, []);

  return (
    <>
      <CssBaseline />
      <Alert
        sx={{ m: 1, px: 1, py: 1, borderRadius: 5, justifyContent: "center" }}
        severity="warning"
      >
        لطفا تا پایان مراحل از این صفحه خارج نشوید
      </Alert>
      {/* <Typography  sx={{ backgroundColor: "#001e6a",m:1, px: 1,py:5, color: "white",borderRadius:5,textAlign:"center" }}>لطفا تا پایان مراحل از این صفحه خارج نشوید</Typography> */}
      <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
        <Paper
          variant="outlined"
          sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
        >
          <Typography component="h1" variant="h4" align="center">
            {activeStep == 1 ? "ثبت کد تخفیف" : "تایید پرداخت"}
          </Typography>
          <Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Typography sx={{ mt: 0, mb: 2 }}>{`مبلغ: ${
            calculatePrice() > 1000 ? calculatePrice() / 1000 : calculatePrice()
          } ${calculatePrice() > 1000 ? "میلیون" : "هزار"} تومان`}</Typography>
          {activeStep === steps.length ? (
            <React.Fragment>
              <Typography variant="h5" gutterBottom>
                Thank you for your order.
              </Typography>
              <Typography variant="subtitle1">
                Your order number is #2001539. We have emailed your order
                confirmation, and will send you an update when your order has
                shipped.
              </Typography>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {getStepContent(activeStep)}
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                {activeStep !== 0 && (
                  <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                    برگشت
                  </Button>
                )}

                {activeStep === steps.length - 1 ? null : (
                  <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{ mt: 3, ml: 1 }}
                  >
                    ادامه و پرداخت
                  </Button>
                )}
              </Box>
            </React.Fragment>
          )}
        </Paper>
        {/* <Copyright /> */}
      </Container>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </>
  );
}
